// Search params da lista de leads (/management/leads): busca (?q=), status
// (?status=) e período de criação (?from=&to=, dias "YYYY-MM-DD") na URL, para
// o recorte sobreviver ao reload e poder ser linkado. Vazio é omitido — sem
// nada na URL a lista mostra todos.
export interface LeadsSearch {
  q?: string;
  status?: string;
  from?: string;
  to?: string;
}

function asText(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

// Dia fora do formato some da URL em vez de virar 422 no back.
function asDay(value: unknown): string | undefined {
  const d = asText(value);
  return d && /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : undefined;
}

export function validateLeadsSearch(raw: Record<string, unknown>): LeadsSearch {
  return {
    q: asText(raw.q),
    status: asText(raw.status),
    from: asDay(raw.from),
    to: asDay(raw.to),
  };
}
